/**
 * Formats a phone number string into US format (XXX) XXX-XXXX
 * @param phoneNumber - The phone number string to format
 * @returns Formatted phone number string or '-' if invalid
 */
export const formatPhoneNumber = (phoneNumber: string | undefined | null): string => {
  if (!phoneNumber) return '-';
  
  // Remove all non-digit characters
  const cleaned = phoneNumber.replace(/\D/g, '');
  
  // Check if the cleaned number has 10 digits
  if (cleaned.length !== 10) return phoneNumber;
  
  // Format as (XXX) XXX-XXXX
  return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(6)}`;
}; 